import React from "react";
import SlidePanel from "../add_customer/SlidePanel";

const SuccessSlidePanel = ({ isSuccessPanelOpen, closeSuccessPanel }) => {
  return (
    <SlidePanel isOpen={isSuccessPanelOpen} onClose={closeSuccessPanel}>
      <div className="flex items-center justify-center h-full bg-white rounded-[12px]">
        <div className="text-center w-full px-6">
          <div className="mt-4 mb-12 mx-auto">
            <img src="/success_image.png" alt="Success" className="mx-auto" />

            <div className="text-[#000] text-[15px] font-normal mt-10">
              <p className="text-lg font-semibold mb-2">Success!</p>

              <p>
                Document read successfully. Review and confirm it matches the
              </p>
              <p>physical identity document provided by the member.</p>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default SuccessSlidePanel;
